import React, { Component } from "react";
import moment from "moment";
import { ChevronLeft, ChevronRight } from "../library/Icons";
import "./MonthSelect.css";

export default class MonthSelect extends Component {
  onDateSelect(date) {
    const weekend =
      moment(date).startOf("month").isoWeekday() === 7
        ? 1
        : moment(date).startOf("month").isoWeekday() === 6
        ? 2
        : 0;
    const day = moment(date)
      .startOf("month")
      .add(weekend, "days")
      .format("YYYY-MM-DD");
    this.props.onDateSelect(day);
  }

  render() {
    const { date } = this.props;

    return (
      <div className="MonthSelect">
        <button
          data-testid="previous-month-button"
          className="MonthSelect__Button"
          onClick={this.onDateSelect.bind(
            this,
            moment(date).subtract(1, "months").format("YYYY-MM-DD HH:mm")
          )}
        >
          <ChevronLeft />
        </button>
        <div data-testid="monthselect-text" className="MonthSelect__Month">
          {moment(date).format("MMMM")} {moment(date).format("YYYY")}
        </div>
        <button
          data-testid="next-month-button"
          className="MonthSelect__Button"
          onClick={this.onDateSelect.bind(
            this,
            moment(date).add(1, "months").format("YYYY-MM-DD HH:mm")
          )}
        >
          <ChevronRight />
        </button>
      </div>
    );
  }
}
